import { cacheDom } from '../utils/QuerySelectors.js'
import { initWishlist, privatePrices } from '../utils/helpers.js'

const dom = {}
const qs = {
  paginator: 'data-paginator',
  results: 'data-pagination-result',
  nav: 'data-pagination-nav',
  tilePaginator: 'data-tile-paginator',
}
const qsAll = {
  loadMoreBtns: 'data-load-more',
}

const initProductCardSwipers = () => {
  const swipers = document.querySelectorAll('[data-product-card-swiper]:not(.swiper-initialized)')
  swipers.forEach((slider) => {
    new Swiper(slider, {
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
    })
  })
}

const iObserver = new IntersectionObserver((items) => {
  if (items[0].isIntersecting) {
    const btn = items[0].target
    const paginator = btn.closest(`[${qs.paginator}]`)
    if (paginator) {
      const results = paginator.querySelector(`[${qs.results}]`)
      fetch(btn.href, { method: 'GET' })
        .then((response) => response.text())
        .then((html) => {
          const parsedHtml = new DOMParser().parseFromString(html, 'text/html')
          const newResults = parsedHtml.querySelectorAll(`[${qs.results}] > *`)

          newResults.forEach((child) => {
            results.appendChild(child)
          })
          window.setupProductTiles(document.querySelectorAll('[product-tile]:empty'))
          window.setupApiTiles(results)

          btn.remove()
          if (parsedHtml.querySelector(`[${qsAll.loadMoreBtns}]`)) {
            const node = document.createElement('a')
            node.href = `${parsedHtml.querySelector(`[${qsAll.loadMoreBtns}]`).href}`
            node.className = 'mx-auto inline-block invisible pagination-load-more'
            node.setAttribute('data-load-more', '')
            node.textContent = 'More Results'
            const nav = paginator.querySelector(`[${qs.nav}]`)
            nav?.insertBefore(node, nav?.firstChild)
            // nav?.appendChild(node)
            iObserver.observe(paginator.querySelector(`[${qsAll.loadMoreBtns}]`))
          }

          GTM_plpViewItems(document.querySelectorAll('#product-grid [data-gtm-items-el]:not(.gtm-item_viewed)'));

          initProductCardSwipers()
          initWishlist()
          privatePrices()
        })
    }
  }
})

const tileObserver = new IntersectionObserver(items => {
  if (items[0].isIntersecting) {
    let tile = items[0].target
    if(tile) {
      fetch(tile.getAttribute(qs.tilePaginator), { method: 'GET' })
        .then((response) => response.text())
        .then((html) => {
          const parsedHtml = new DOMParser().parseFromString(html, 'text/html')
          const newResults = parsedHtml.querySelectorAll(`[${qs.results}] > *`)


          tile.removeAttribute(qs.tilePaginator)
          newResults.forEach((child) => {
            const id = child.getAttribute('data-plp-item')
            if(!dom.results.querySelector(`[data-plp-item="${id}"]`)) dom.results.appendChild(child)
          })
          window.setupProductTiles(document.querySelectorAll('[product-tile]:empty'))
          window.setupApiTiles(dom.results)

          setTimeout(() => {
            window._swat.initializeActionButtons(`#product-grid`, '.plp-wishlist-btn')
          }, 300)

          const tiles = document.querySelectorAll(`[${qs.tilePaginator}]`)
          tiles.forEach(t => tileObserver.observe(t))
        })
    }
  }
})

export const setupPaginations = () => {
  cacheDom(dom, qs, qsAll)
  dom.loadMoreBtns.forEach((btn) => iObserver.observe(btn))
  if(dom.tilePaginator) tileObserver.observe(dom.tilePaginator)
}
